import { createSlice } from "@reduxjs/toolkit";
import {
  initStateApipayCheckout,
  reducerApipayCheckout,
} from "../actions/payment/apipayCheckout";
import {
  initStateApipayOrderStatus,
  reducerApipayOrderStatus,
} from "../actions/payment/apipayOrderStatus";
import {
  initStateApipayGetPhones,
  reducerApipayGetPhones,
} from "../actions/payment/apipayGetPhones";
import {
  initStateSubscriptionList,
  reducerSubscriptionList,
} from "../actions/payment/subscriptionList";
import {
  initStateSubscriptionAction,
  reducerSubscriptionAction,
} from "../actions/payment/subscriptionAction";
import {
  initStateAdminInvoiceList,
  reducerAdminInvoiceList,
} from "../actions/payment/adminInvoiceList";
import {
  initStateAdminInvoiceStats,
  reducerAdminInvoiceStats,
} from "../actions/payment/adminInvoiceStats";
import {
  initStateAdminProfileHistory,
  reducerAdminProfileHistory,
} from "../actions/payment/adminProfileHistory";
import {
  initStateAdminUnifiedActivity,
  reducerAdminUnifiedActivity,
} from "../actions/payment/adminUnifiedActivity";

export const initialState = {
  ...initStateApipayCheckout,
  ...initStateApipayOrderStatus,
  ...initStateApipayGetPhones,
  ...initStateSubscriptionList,
  ...initStateSubscriptionAction,
  ...initStateAdminInvoiceList,
  ...initStateAdminInvoiceStats,
  ...initStateAdminProfileHistory,
  ...initStateAdminUnifiedActivity,
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    resetApipayCheckout(state) {
      state.apipayCheckout = initStateApipayCheckout.apipayCheckout;
    },
    resetApipayOrderStatus(state) {
      state.apipayOrderStatus = initStateApipayOrderStatus.apipayOrderStatus;
    },
    resetSubscriptionAction(state) {
      state.subscriptionAction = initStateSubscriptionAction.subscriptionAction;
    },
  },
  extraReducers: {
    ...reducerApipayCheckout,
    ...reducerApipayOrderStatus,
    ...reducerApipayGetPhones,
    ...reducerSubscriptionList,
    ...reducerSubscriptionAction,
    ...reducerAdminInvoiceList,
    ...reducerAdminInvoiceStats,
    ...reducerAdminProfileHistory,
    ...reducerAdminUnifiedActivity,
  },
});

export const { resetApipayCheckout, resetApipayOrderStatus, resetSubscriptionAction } =
  paymentSlice.actions;
export const paymentReducer = paymentSlice.reducer;

